import { render, staticRenderFns } from "./evolution-compact.vue?vue&type=template&id=532a1412&scoped=true"
import script from "./evolution-compact.vue?vue&type=script&lang=js"
export * from "./evolution-compact.vue?vue&type=script&lang=js"
import style0 from "./evolution-compact.vue?vue&type=style&index=0&id=532a1412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a1412",
  null
  
)

export default component.exports